"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendOpenWindowEvent = exports.subscribeOnLocationChanged = exports.sendLocationChanged = exports.requestInitialData = exports.requestCredentials = exports.requestParentWindow = exports.WindowEventTypes = void 0;
var tslib_1 = require("tslib");
var ORIGIN_SUFFIX = 'bringg.com';
var WindowEventTypes;
(function (WindowEventTypes) {
    WindowEventTypes["RequestCredentials"] = "request_creds";
    WindowEventTypes["RequestInitialData"] = "request_initial_data";
    WindowEventTypes["Credentials"] = "creds";
    WindowEventTypes["InitialData"] = "initial_date";
    WindowEventTypes["LocationChanged"] = "location_changed";
    WindowEventTypes["OpenWindow"] = "open_window";
})(WindowEventTypes || (exports.WindowEventTypes = WindowEventTypes = {}));
var messageDisposer = function (reject, messageHandler, waitTime) {
    setTimeout(function () {
        window.removeEventListener('message', messageHandler);
        reject('No Credentials from father :/');
    }, waitTime);
};
var onMessage = function (eventType, resolve, reject, ignoreOrigin) { return function (event) {
    var data = event.data, origin = event.origin;
    if (!data && !origin) {
        console.warn('Received bad message, ignoring');
        return;
    }
    if (!origin.endsWith(ORIGIN_SUFFIX) && !ignoreOrigin) {
        var msg = "Received unwanted message from ".concat(origin);
        console.error(msg);
        reject(msg);
    }
    if (data.type === eventType) {
        delete data.type;
        resolve(data);
    }
}; };
var requestParentWindow = function (_a) {
    var outgoingEventType = _a.outgoingEventType, incomingEventType = _a.incomingEventType, _b = _a.windowConsumer, windowConsumer = _b === void 0 ? null : _b, _c = _a.waitTime, waitTime = _c === void 0 ? 1000 : _c, _d = _a.ignoreOrigin, ignoreOrigin = _d === void 0 ? false : _d;
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_e) {
            return [2, new Promise(function (resolve, reject) {
                    var messageHandler = onMessage(incomingEventType, resolve, reject, ignoreOrigin);
                    messageDisposer(reject, messageHandler, waitTime);
                    if (windowConsumer) {
                        windowConsumer.postMessage(outgoingEventType, '*');
                    }
                    else {
                        window.parent.postMessage(outgoingEventType, '*');
                    }
                    window.addEventListener('message', messageHandler, false);
                })];
        });
    });
};
exports.requestParentWindow = requestParentWindow;
var requestCredentials = function (_a) {
    var _b = _a.windowConsumer, windowConsumer = _b === void 0 ? null : _b, _c = _a.waitTime, waitTime = _c === void 0 ? 1000 : _c, _d = _a.ignoreOrigin, ignoreOrigin = _d === void 0 ? false : _d;
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var data;
        return tslib_1.__generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4, requestParentWindow({
                        outgoingEventType: WindowEventTypes.RequestCredentials,
                        incomingEventType: WindowEventTypes.Credentials,
                        windowConsumer: windowConsumer,
                        waitTime: waitTime,
                        ignoreOrigin: ignoreOrigin
                    })];
                case 1:
                    data = _e.sent();
                    return [2, {
                            token: data.token,
                            region: data.region
                        }];
            }
        });
    });
};
exports.requestCredentials = requestCredentials;
var requestInitialData = function (_a) {
    var _b = _a.windowConsumer, windowConsumer = _b === void 0 ? null : _b, _c = _a.waitTime, waitTime = _c === void 0 ? 1000 : _c, _d = _a.ignoreOrigin, ignoreOrigin = _d === void 0 ? false : _d;
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4, requestParentWindow({
                        outgoingEventType: WindowEventTypes.RequestInitialData,
                        incomingEventType: WindowEventTypes.InitialData,
                        windowConsumer: windowConsumer,
                        waitTime: waitTime,
                        ignoreOrigin: ignoreOrigin
                    })];
                case 1: return [2, _e.sent()];
            }
        });
    });
};
exports.requestInitialData = requestInitialData;
var sendLocationChanged = function (path, windowConsumer) {
    if (windowConsumer === void 0) { windowConsumer = null; }
    (windowConsumer !== null && windowConsumer !== void 0 ? windowConsumer : window.parent).postMessage({
        type: WindowEventTypes.LocationChanged,
        path: path
    }, '*');
};
exports.sendLocationChanged = sendLocationChanged;
var sendOpenWindowEvent = function (path, windowConsumer) {
    if (windowConsumer === void 0) { windowConsumer = null; }
    (windowConsumer !== null && windowConsumer !== void 0 ? windowConsumer : window.parent).postMessage({
        type: WindowEventTypes.OpenWindow,
        path: path
    }, '*');
};
exports.sendOpenWindowEvent = sendOpenWindowEvent;
var subscribeOnLocationChanged = function (onChange, ignoreOrigin) {
    if (ignoreOrigin === void 0) { ignoreOrigin = false; }
    var messageHandler = onMessage(WindowEventTypes.LocationChanged, function (data) {
        onChange(String(data === null || data === void 0 ? void 0 : data.path));
    }, function () { return null; }, ignoreOrigin);
    window.addEventListener('message', messageHandler, false);
    return function () {
        window.removeEventListener('message', messageHandler);
    };
};
exports.subscribeOnLocationChanged = subscribeOnLocationChanged;
//# sourceMappingURL=parent-window-communication.js.map